import { ProductPageStore } from './productPageStore';
import { getRuntimeStyleParams } from '../commons/styleParamsService';
import { withErrorReporting } from '@wix/wixstores-client-core/dist/es/src/viewer-script/errorReporter';
import { wixCodeGetProduct } from '../services/getProduct';
import { withPropsSerialization } from '@wix/native-components-infra/dist/es/src/utils/propsSerializer';
export function productPageController(_a) {
    var context = _a.context, config = _a.config, compId = _a.compId, setProps = _a.setProps, reportError = _a.reportError;
    var productPageStore;
    var siteStore = context.siteStore;
    var styleParams = config.style.styleParams, publicData = config.publicData, _b = config.externalId, externalId = _b === void 0 ? '' : _b;
    var getStyleParams = function (newStyleParams) {
        return getRuntimeStyleParams(newStyleParams || styleParams, { formFactor: siteStore.formFactor });
    };
    return {
        pageReady: function () {
            productPageStore = new ProductPageStore(getStyleParams(), publicData, withPropsSerialization(setProps), siteStore, externalId, compId);
            return productPageStore.setInitialState();
        },
        updateConfig: function (_$w, _a) {
            var newStyleParams = _a.style.styleParams, newPublicData = _a.publicData;
            productPageStore.updateState(getStyleParams(newStyleParams), newPublicData);
        },
        exports: function () {
            return withErrorReporting(reportError)({
                getProduct: function () { return wixCodeGetProduct(siteStore, reportError); },
            });
        },
    };
}
//# sourceMappingURL=productPageController.js.map